import classNames from 'classnames';
import type { HTMLAttributes, ReactNode } from 'react';

import styles from './themed-status-tag.module.css';

export type StatusTone = 'inProgress' | 'finished' | 'failed' | 'neutral';

interface ThemedStatusTagProps extends HTMLAttributes<HTMLSpanElement> {
  tone: StatusTone;
  children: ReactNode;
}

/**
 * Solid status pill used by the Report-Status and Delivery-Status grids.
 * Presentational only — callers decide which `tone`/label to pass.
 * Colour/text-per-theme lives in the co-located CSS module.
 */
export const ThemedStatusTag = ({
  tone,
  children,
  className,
  ...rest
}: ThemedStatusTagProps) => (
  <span className={classNames(styles.tag, styles[tone], className)} {...rest}>
    {children}
  </span>
);
